/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as SidebarRouteImport } from './routes/_sidebar'
import { Route as SidebarIndexRouteImport } from './routes/_sidebar/index'
import { Route as SimulazioniIdRouteImport } from './routes/simulazioni.$id'
import { Route as OrientamentoSurveyIdRouteImport } from './routes/orientamento.$surveyId'
import { Route as MieDomandeCreaSbagliateRouteImport } from './routes/mie-domande.crea-sbagliate'
import { Route as MieDomandeCreaRouteImport } from './routes/mie-domande.crea'
import { Route as MieDomandeIdRouteImport } from './routes/mie-domande.$id'
import { Route as ImpersonationStartRouteImport } from './routes/impersonation.start'
import { Route as EsercitazioniCreaRouteImport } from './routes/esercitazioni.crea'
import { Route as EsercitazioniIdRouteImport } from './routes/esercitazioni.$id'
import { Route as SidebarSimulazioniRouteImport } from './routes/_sidebar/simulazioni'
import { Route as SidebarRisorseGratuiteRouteImport } from './routes/_sidebar/risorse-gratuite'
import { Route as SidebarProveUfficialiRouteImport } from './routes/_sidebar/prove-ufficiali'
import { Route as SidebarProfiloRouteImport } from './routes/_sidebar/profilo'
import { Route as SidebarOrientamentoRouteImport } from './routes/_sidebar/orientamento'
import { Route as SidebarMieDomandeRouteImport } from './routes/_sidebar/mie-domande'
import { Route as SidebarEsercitazioniRouteImport } from './routes/_sidebar/esercitazioni'
import { Route as SidebarStatisticheIndexRouteImport } from './routes/_sidebar/statistiche/index'
import { Route as SidebarOrientamentoIndexRouteImport } from './routes/_sidebar/orientamento.index'
import { Route as SidebarGraduatorieIndexRouteImport } from './routes/_sidebar/graduatorie/index'
import { Route as SimulazioniIdCorrezioneRouteImport } from './routes/simulazioni.$id_.correzione'
import { Route as EsercitazioniIdCorrezioneRouteImport } from './routes/esercitazioni.$id_.correzione'
import { Route as SidebarStatisticheMaterieRouteImport } from './routes/_sidebar/statistiche/materie'
import { Route as SidebarStatisticheArgomentiRouteImport } from './routes/_sidebar/statistiche/argomenti'
import { Route as SidebarGraduatorieIdRouteImport } from './routes/_sidebar/graduatorie/$id'

const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SidebarRoute = SidebarRouteImport.update({
  id: '/_sidebar',
  getParentRoute: () => rootRouteImport,
} as any)
const SidebarIndexRoute = SidebarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SidebarRoute,
} as any)
const SimulazioniIdRoute = SimulazioniIdRouteImport.update({
  id: '/simulazioni/$id',
  path: '/simulazioni/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OrientamentoSurveyIdRoute = OrientamentoSurveyIdRouteImport.update({
  id: '/orientamento/$surveyId',
  path: '/orientamento/$surveyId',
  getParentRoute: () => rootRouteImport,
} as any)
const MieDomandeCreaSbagliateRoute = MieDomandeCreaSbagliateRouteImport.update({
  id: '/mie-domande/crea-sbagliate',
  path: '/mie-domande/crea-sbagliate',
  getParentRoute: () => rootRouteImport,
} as any)
const MieDomandeCreaRoute = MieDomandeCreaRouteImport.update({
  id: '/mie-domande/crea',
  path: '/mie-domande/crea',
  getParentRoute: () => rootRouteImport,
} as any)
const MieDomandeIdRoute = MieDomandeIdRouteImport.update({
  id: '/mie-domande/$id',
  path: '/mie-domande/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonationStartRoute = ImpersonationStartRouteImport.update({
  id: '/impersonation/start',
  path: '/impersonation/start',
  getParentRoute: () => rootRouteImport,
} as any)
const EsercitazioniCreaRoute = EsercitazioniCreaRouteImport.update({
  id: '/esercitazioni/crea',
  path: '/esercitazioni/crea',
  getParentRoute: () => rootRouteImport,
} as any)
const EsercitazioniIdRoute = EsercitazioniIdRouteImport.update({
  id: '/esercitazioni/$id',
  path: '/esercitazioni/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SidebarSimulazioniRoute = SidebarSimulazioniRouteImport.update({
  id: '/simulazioni',
  path: '/simulazioni',
  getParentRoute: () => SidebarRoute,
} as any)
const SidebarRisorseGratuiteRoute = SidebarRisorseGratuiteRouteImport.update({
  id: '/risorse-gratuite',
  path: '/risorse-gratuite',
  getParentRoute: () => SidebarRoute,
} as any)
const SidebarProveUfficialiRoute = SidebarProveUfficialiRouteImport.update({
  id: '/prove-ufficiali',
  path: '/prove-ufficiali',
  getParentRoute: () => SidebarRoute,
} as any)
const SidebarProfiloRoute = SidebarProfiloRouteImport.update({
  id: '/profilo',
  path: '/profilo',
  getParentRoute: () => SidebarRoute,
} as any)
const SidebarOrientamentoRoute = SidebarOrientamentoRouteImport.update({
  id: '/orientamento',
  path: '/orientamento',
  getParentRoute: () => SidebarRoute,
} as any)
const SidebarMieDomandeRoute = SidebarMieDomandeRouteImport.update({
  id: '/mie-domande',
  path: '/mie-domande',
  getParentRoute: () => SidebarRoute,
} as any)
const SidebarEsercitazioniRoute = SidebarEsercitazioniRouteImport.update({
  id: '/esercitazioni',
  path: '/esercitazioni',
  getParentRoute: () => SidebarRoute,
} as any)
const SidebarStatisticheIndexRoute = SidebarStatisticheIndexRouteImport.update({
  id: '/statistiche/',
  path: '/statistiche/',
  getParentRoute: () => SidebarRoute,
} as any)
const SidebarOrientamentoIndexRoute =
  SidebarOrientamentoIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SidebarOrientamentoRoute,
  } as any)
const SidebarGraduatorieIndexRoute = SidebarGraduatorieIndexRouteImport.update({
  id: '/graduatorie/',
  path: '/graduatorie/',
  getParentRoute: () => SidebarRoute,
} as any)
const SimulazioniIdCorrezioneRoute = SimulazioniIdCorrezioneRouteImport.update({
  id: '/simulazioni/$id_/correzione',
  path: '/simulazioni/$id/correzione',
  getParentRoute: () => rootRouteImport,
} as any)
const EsercitazioniIdCorrezioneRoute =
  EsercitazioniIdCorrezioneRouteImport.update({
    id: '/esercitazioni/$id_/correzione',
    path: '/esercitazioni/$id/correzione',
    getParentRoute: () => rootRouteImport,
  } as any)
const SidebarStatisticheMaterieRoute =
  SidebarStatisticheMaterieRouteImport.update({
    id: '/statistiche/materie',
    path: '/statistiche/materie',
    getParentRoute: () => SidebarRoute,
  } as any)
const SidebarStatisticheArgomentiRoute =
  SidebarStatisticheArgomentiRouteImport.update({
    id: '/statistiche/argomenti',
    path: '/statistiche/argomenti',
    getParentRoute: () => SidebarRoute,
  } as any)
const SidebarGraduatorieIdRoute = SidebarGraduatorieIdRouteImport.update({
  id: '/graduatorie/$id',
  path: '/graduatorie/$id',
  getParentRoute: () => SidebarRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof SidebarIndexRoute
  '/callback': typeof CallbackRoute
  '/esercitazioni': typeof SidebarEsercitazioniRoute
  '/mie-domande': typeof SidebarMieDomandeRoute
  '/orientamento': typeof SidebarOrientamentoRouteWithChildren
  '/profilo': typeof SidebarProfiloRoute
  '/prove-ufficiali': typeof SidebarProveUfficialiRoute
  '/risorse-gratuite': typeof SidebarRisorseGratuiteRoute
  '/simulazioni': typeof SidebarSimulazioniRoute
  '/esercitazioni/$id': typeof EsercitazioniIdRoute
  '/esercitazioni/crea': typeof EsercitazioniCreaRoute
  '/impersonation/start': typeof ImpersonationStartRoute
  '/mie-domande/$id': typeof MieDomandeIdRoute
  '/mie-domande/crea': typeof MieDomandeCreaRoute
  '/mie-domande/crea-sbagliate': typeof MieDomandeCreaSbagliateRoute
  '/orientamento/$surveyId': typeof OrientamentoSurveyIdRoute
  '/simulazioni/$id': typeof SimulazioniIdRoute
  '/graduatorie/$id': typeof SidebarGraduatorieIdRoute
  '/statistiche/argomenti': typeof SidebarStatisticheArgomentiRoute
  '/statistiche/materie': typeof SidebarStatisticheMaterieRoute
  '/esercitazioni/$id/correzione': typeof EsercitazioniIdCorrezioneRoute
  '/simulazioni/$id/correzione': typeof SimulazioniIdCorrezioneRoute
  '/graduatorie/': typeof SidebarGraduatorieIndexRoute
  '/orientamento/': typeof SidebarOrientamentoIndexRoute
  '/statistiche/': typeof SidebarStatisticheIndexRoute
}
export interface FileRoutesByTo {
  '/callback': typeof CallbackRoute
  '/esercitazioni': typeof SidebarEsercitazioniRoute
  '/mie-domande': typeof SidebarMieDomandeRoute
  '/profilo': typeof SidebarProfiloRoute
  '/prove-ufficiali': typeof SidebarProveUfficialiRoute
  '/risorse-gratuite': typeof SidebarRisorseGratuiteRoute
  '/simulazioni': typeof SidebarSimulazioniRoute
  '/esercitazioni/$id': typeof EsercitazioniIdRoute
  '/esercitazioni/crea': typeof EsercitazioniCreaRoute
  '/impersonation/start': typeof ImpersonationStartRoute
  '/mie-domande/$id': typeof MieDomandeIdRoute
  '/mie-domande/crea': typeof MieDomandeCreaRoute
  '/mie-domande/crea-sbagliate': typeof MieDomandeCreaSbagliateRoute
  '/orientamento/$surveyId': typeof OrientamentoSurveyIdRoute
  '/simulazioni/$id': typeof SimulazioniIdRoute
  '/': typeof SidebarIndexRoute
  '/graduatorie/$id': typeof SidebarGraduatorieIdRoute
  '/statistiche/argomenti': typeof SidebarStatisticheArgomentiRoute
  '/statistiche/materie': typeof SidebarStatisticheMaterieRoute
  '/esercitazioni/$id/correzione': typeof EsercitazioniIdCorrezioneRoute
  '/simulazioni/$id/correzione': typeof SimulazioniIdCorrezioneRoute
  '/graduatorie': typeof SidebarGraduatorieIndexRoute
  '/orientamento': typeof SidebarOrientamentoIndexRoute
  '/statistiche': typeof SidebarStatisticheIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_sidebar': typeof SidebarRouteWithChildren
  '/callback': typeof CallbackRoute
  '/_sidebar/esercitazioni': typeof SidebarEsercitazioniRoute
  '/_sidebar/mie-domande': typeof SidebarMieDomandeRoute
  '/_sidebar/orientamento': typeof SidebarOrientamentoRouteWithChildren
  '/_sidebar/profilo': typeof SidebarProfiloRoute
  '/_sidebar/prove-ufficiali': typeof SidebarProveUfficialiRoute
  '/_sidebar/risorse-gratuite': typeof SidebarRisorseGratuiteRoute
  '/_sidebar/simulazioni': typeof SidebarSimulazioniRoute
  '/esercitazioni/$id': typeof EsercitazioniIdRoute
  '/esercitazioni/crea': typeof EsercitazioniCreaRoute
  '/impersonation/start': typeof ImpersonationStartRoute
  '/mie-domande/$id': typeof MieDomandeIdRoute
  '/mie-domande/crea': typeof MieDomandeCreaRoute
  '/mie-domande/crea-sbagliate': typeof MieDomandeCreaSbagliateRoute
  '/orientamento/$surveyId': typeof OrientamentoSurveyIdRoute
  '/simulazioni/$id': typeof SimulazioniIdRoute
  '/_sidebar/': typeof SidebarIndexRoute
  '/_sidebar/graduatorie/$id': typeof SidebarGraduatorieIdRoute
  '/_sidebar/statistiche/argomenti': typeof SidebarStatisticheArgomentiRoute
  '/_sidebar/statistiche/materie': typeof SidebarStatisticheMaterieRoute
  '/esercitazioni/$id_/correzione': typeof EsercitazioniIdCorrezioneRoute
  '/simulazioni/$id_/correzione': typeof SimulazioniIdCorrezioneRoute
  '/_sidebar/graduatorie/': typeof SidebarGraduatorieIndexRoute
  '/_sidebar/orientamento/': typeof SidebarOrientamentoIndexRoute
  '/_sidebar/statistiche/': typeof SidebarStatisticheIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/esercitazioni'
    | '/mie-domande'
    | '/orientamento'
    | '/profilo'
    | '/prove-ufficiali'
    | '/risorse-gratuite'
    | '/simulazioni'
    | '/esercitazioni/$id'
    | '/esercitazioni/crea'
    | '/impersonation/start'
    | '/mie-domande/$id'
    | '/mie-domande/crea'
    | '/mie-domande/crea-sbagliate'
    | '/orientamento/$surveyId'
    | '/simulazioni/$id'
    | '/graduatorie/$id'
    | '/statistiche/argomenti'
    | '/statistiche/materie'
    | '/esercitazioni/$id/correzione'
    | '/simulazioni/$id/correzione'
    | '/graduatorie/'
    | '/orientamento/'
    | '/statistiche/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/callback'
    | '/esercitazioni'
    | '/mie-domande'
    | '/profilo'
    | '/prove-ufficiali'
    | '/risorse-gratuite'
    | '/simulazioni'
    | '/esercitazioni/$id'
    | '/esercitazioni/crea'
    | '/impersonation/start'
    | '/mie-domande/$id'
    | '/mie-domande/crea'
    | '/mie-domande/crea-sbagliate'
    | '/orientamento/$surveyId'
    | '/simulazioni/$id'
    | '/'
    | '/graduatorie/$id'
    | '/statistiche/argomenti'
    | '/statistiche/materie'
    | '/esercitazioni/$id/correzione'
    | '/simulazioni/$id/correzione'
    | '/graduatorie'
    | '/orientamento'
    | '/statistiche'
  id:
    | '__root__'
    | '/_sidebar'
    | '/callback'
    | '/_sidebar/esercitazioni'
    | '/_sidebar/mie-domande'
    | '/_sidebar/orientamento'
    | '/_sidebar/profilo'
    | '/_sidebar/prove-ufficiali'
    | '/_sidebar/risorse-gratuite'
    | '/_sidebar/simulazioni'
    | '/esercitazioni/$id'
    | '/esercitazioni/crea'
    | '/impersonation/start'
    | '/mie-domande/$id'
    | '/mie-domande/crea'
    | '/mie-domande/crea-sbagliate'
    | '/orientamento/$surveyId'
    | '/simulazioni/$id'
    | '/_sidebar/'
    | '/_sidebar/graduatorie/$id'
    | '/_sidebar/statistiche/argomenti'
    | '/_sidebar/statistiche/materie'
    | '/esercitazioni/$id_/correzione'
    | '/simulazioni/$id_/correzione'
    | '/_sidebar/graduatorie/'
    | '/_sidebar/orientamento/'
    | '/_sidebar/statistiche/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SidebarRoute: typeof SidebarRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  EsercitazioniIdRoute: typeof EsercitazioniIdRoute
  EsercitazioniCreaRoute: typeof EsercitazioniCreaRoute
  ImpersonationStartRoute: typeof ImpersonationStartRoute
  MieDomandeIdRoute: typeof MieDomandeIdRoute
  MieDomandeCreaRoute: typeof MieDomandeCreaRoute
  MieDomandeCreaSbagliateRoute: typeof MieDomandeCreaSbagliateRoute
  OrientamentoSurveyIdRoute: typeof OrientamentoSurveyIdRoute
  SimulazioniIdRoute: typeof SimulazioniIdRoute
  EsercitazioniIdCorrezioneRoute: typeof EsercitazioniIdCorrezioneRoute
  SimulazioniIdCorrezioneRoute: typeof SimulazioniIdCorrezioneRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_sidebar': {
      id: '/_sidebar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SidebarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_sidebar/': {
      id: '/_sidebar/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof SidebarIndexRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/simulazioni/$id': {
      id: '/simulazioni/$id'
      path: '/simulazioni/$id'
      fullPath: '/simulazioni/$id'
      preLoaderRoute: typeof SimulazioniIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orientamento/$surveyId': {
      id: '/orientamento/$surveyId'
      path: '/orientamento/$surveyId'
      fullPath: '/orientamento/$surveyId'
      preLoaderRoute: typeof OrientamentoSurveyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mie-domande/crea-sbagliate': {
      id: '/mie-domande/crea-sbagliate'
      path: '/mie-domande/crea-sbagliate'
      fullPath: '/mie-domande/crea-sbagliate'
      preLoaderRoute: typeof MieDomandeCreaSbagliateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mie-domande/crea': {
      id: '/mie-domande/crea'
      path: '/mie-domande/crea'
      fullPath: '/mie-domande/crea'
      preLoaderRoute: typeof MieDomandeCreaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mie-domande/$id': {
      id: '/mie-domande/$id'
      path: '/mie-domande/$id'
      fullPath: '/mie-domande/$id'
      preLoaderRoute: typeof MieDomandeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonation/start': {
      id: '/impersonation/start'
      path: '/impersonation/start'
      fullPath: '/impersonation/start'
      preLoaderRoute: typeof ImpersonationStartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/esercitazioni/crea': {
      id: '/esercitazioni/crea'
      path: '/esercitazioni/crea'
      fullPath: '/esercitazioni/crea'
      preLoaderRoute: typeof EsercitazioniCreaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/esercitazioni/$id': {
      id: '/esercitazioni/$id'
      path: '/esercitazioni/$id'
      fullPath: '/esercitazioni/$id'
      preLoaderRoute: typeof EsercitazioniIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_sidebar/simulazioni': {
      id: '/_sidebar/simulazioni'
      path: '/simulazioni'
      fullPath: '/simulazioni'
      preLoaderRoute: typeof SidebarSimulazioniRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/risorse-gratuite': {
      id: '/_sidebar/risorse-gratuite'
      path: '/risorse-gratuite'
      fullPath: '/risorse-gratuite'
      preLoaderRoute: typeof SidebarRisorseGratuiteRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/prove-ufficiali': {
      id: '/_sidebar/prove-ufficiali'
      path: '/prove-ufficiali'
      fullPath: '/prove-ufficiali'
      preLoaderRoute: typeof SidebarProveUfficialiRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/profilo': {
      id: '/_sidebar/profilo'
      path: '/profilo'
      fullPath: '/profilo'
      preLoaderRoute: typeof SidebarProfiloRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/orientamento': {
      id: '/_sidebar/orientamento'
      path: '/orientamento'
      fullPath: '/orientamento'
      preLoaderRoute: typeof SidebarOrientamentoRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/mie-domande': {
      id: '/_sidebar/mie-domande'
      path: '/mie-domande'
      fullPath: '/mie-domande'
      preLoaderRoute: typeof SidebarMieDomandeRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/esercitazioni': {
      id: '/_sidebar/esercitazioni'
      path: '/esercitazioni'
      fullPath: '/esercitazioni'
      preLoaderRoute: typeof SidebarEsercitazioniRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/statistiche/': {
      id: '/_sidebar/statistiche/'
      path: '/statistiche'
      fullPath: '/statistiche/'
      preLoaderRoute: typeof SidebarStatisticheIndexRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/orientamento/': {
      id: '/_sidebar/orientamento/'
      path: '/'
      fullPath: '/orientamento/'
      preLoaderRoute: typeof SidebarOrientamentoIndexRouteImport
      parentRoute: typeof SidebarOrientamentoRoute
    }
    '/_sidebar/graduatorie/': {
      id: '/_sidebar/graduatorie/'
      path: '/graduatorie'
      fullPath: '/graduatorie/'
      preLoaderRoute: typeof SidebarGraduatorieIndexRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/simulazioni/$id_/correzione': {
      id: '/simulazioni/$id_/correzione'
      path: '/simulazioni/$id/correzione'
      fullPath: '/simulazioni/$id/correzione'
      preLoaderRoute: typeof SimulazioniIdCorrezioneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/esercitazioni/$id_/correzione': {
      id: '/esercitazioni/$id_/correzione'
      path: '/esercitazioni/$id/correzione'
      fullPath: '/esercitazioni/$id/correzione'
      preLoaderRoute: typeof EsercitazioniIdCorrezioneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_sidebar/statistiche/materie': {
      id: '/_sidebar/statistiche/materie'
      path: '/statistiche/materie'
      fullPath: '/statistiche/materie'
      preLoaderRoute: typeof SidebarStatisticheMaterieRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/statistiche/argomenti': {
      id: '/_sidebar/statistiche/argomenti'
      path: '/statistiche/argomenti'
      fullPath: '/statistiche/argomenti'
      preLoaderRoute: typeof SidebarStatisticheArgomentiRouteImport
      parentRoute: typeof SidebarRoute
    }
    '/_sidebar/graduatorie/$id': {
      id: '/_sidebar/graduatorie/$id'
      path: '/graduatorie/$id'
      fullPath: '/graduatorie/$id'
      preLoaderRoute: typeof SidebarGraduatorieIdRouteImport
      parentRoute: typeof SidebarRoute
    }
  }
}

interface SidebarOrientamentoRouteChildren {
  SidebarOrientamentoIndexRoute: typeof SidebarOrientamentoIndexRoute
}

const SidebarOrientamentoRouteChildren: SidebarOrientamentoRouteChildren = {
  SidebarOrientamentoIndexRoute: SidebarOrientamentoIndexRoute,
}

const SidebarOrientamentoRouteWithChildren =
  SidebarOrientamentoRoute._addFileChildren(SidebarOrientamentoRouteChildren)

interface SidebarRouteChildren {
  SidebarEsercitazioniRoute: typeof SidebarEsercitazioniRoute
  SidebarMieDomandeRoute: typeof SidebarMieDomandeRoute
  SidebarOrientamentoRoute: typeof SidebarOrientamentoRouteWithChildren
  SidebarProfiloRoute: typeof SidebarProfiloRoute
  SidebarProveUfficialiRoute: typeof SidebarProveUfficialiRoute
  SidebarRisorseGratuiteRoute: typeof SidebarRisorseGratuiteRoute
  SidebarSimulazioniRoute: typeof SidebarSimulazioniRoute
  SidebarIndexRoute: typeof SidebarIndexRoute
  SidebarGraduatorieIdRoute: typeof SidebarGraduatorieIdRoute
  SidebarStatisticheArgomentiRoute: typeof SidebarStatisticheArgomentiRoute
  SidebarStatisticheMaterieRoute: typeof SidebarStatisticheMaterieRoute
  SidebarGraduatorieIndexRoute: typeof SidebarGraduatorieIndexRoute
  SidebarStatisticheIndexRoute: typeof SidebarStatisticheIndexRoute
}

const SidebarRouteChildren: SidebarRouteChildren = {
  SidebarEsercitazioniRoute: SidebarEsercitazioniRoute,
  SidebarMieDomandeRoute: SidebarMieDomandeRoute,
  SidebarOrientamentoRoute: SidebarOrientamentoRouteWithChildren,
  SidebarProfiloRoute: SidebarProfiloRoute,
  SidebarProveUfficialiRoute: SidebarProveUfficialiRoute,
  SidebarRisorseGratuiteRoute: SidebarRisorseGratuiteRoute,
  SidebarSimulazioniRoute: SidebarSimulazioniRoute,
  SidebarIndexRoute: SidebarIndexRoute,
  SidebarGraduatorieIdRoute: SidebarGraduatorieIdRoute,
  SidebarStatisticheArgomentiRoute: SidebarStatisticheArgomentiRoute,
  SidebarStatisticheMaterieRoute: SidebarStatisticheMaterieRoute,
  SidebarGraduatorieIndexRoute: SidebarGraduatorieIndexRoute,
  SidebarStatisticheIndexRoute: SidebarStatisticheIndexRoute,
}

const SidebarRouteWithChildren =
  SidebarRoute._addFileChildren(SidebarRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SidebarRoute: SidebarRouteWithChildren,
  CallbackRoute: CallbackRoute,
  EsercitazioniIdRoute: EsercitazioniIdRoute,
  EsercitazioniCreaRoute: EsercitazioniCreaRoute,
  ImpersonationStartRoute: ImpersonationStartRoute,
  MieDomandeIdRoute: MieDomandeIdRoute,
  MieDomandeCreaRoute: MieDomandeCreaRoute,
  MieDomandeCreaSbagliateRoute: MieDomandeCreaSbagliateRoute,
  OrientamentoSurveyIdRoute: OrientamentoSurveyIdRoute,
  SimulazioniIdRoute: SimulazioniIdRoute,
  EsercitazioniIdCorrezioneRoute: EsercitazioniIdCorrezioneRoute,
  SimulazioniIdCorrezioneRoute: SimulazioniIdCorrezioneRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
